<template>
  <div class="input-group">
    <input
      type="search"
      class="form-control form-control-lg"
      :placeholder="placeholder"
      id="number"
      v-model="number"
    />

    <button
      type="button"
      class="input-group-text btn-success"
      :disabled="isEmpty"
      @click="$emit('search', number)"
    >
      <i class="bi bi-search"></i>
    </button>
  </div>
  <div class="text-center text-dark " v-if="!isEmpty">
    <p v-if="!isNumeric || !isValid">
      {{ description }} numbers should be numeric and contain {{ digitAmount }}
    </p>
  </div>
</template>
<script setup>
import { ref, computed, watch } from "vue";
const props = defineProps({
  min: {
    type: Number,
    required: true,
  },
  max: {
    type: Number,
    required: true,
  },
  placeholder: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  reset: {
    type: Boolean,
  },
});

watch(
  () => props.reset,
  (value) => {
    if (value) number.value = "";
  }
);
const number = ref("");
const isNumeric = computed(() => !isNaN(number.value));
const isValid = computed(
  () =>
    number.value &&
    number.value.length >= props.min &&
    number.value.length <= props.max
);

const digitAmount = computed(() => {
  if (props.min === props.max) {
    return `${props.min} digits`;
  } else {
    return `between ${props.min} and ${props.max} digits`;
  }
});
const isEmpty = computed(() => number.value == "");
const $emit = defineEmits(["search"]);
</script>

<style scoped>
.form-control:focus {
  box-shadow: 0 0 0 0.1rem rgb(13 110 253 / 25%);
}
</style>
